import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import BillWorkspace from "@/pages/BillWorkspace";
import SharePage from "@/pages/SharePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/bill/:id" element={<BillWorkspace />} />
          <Route path="/s/:token" element={<SharePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" closeButton />
    </div>
  );
}

export default App;
